import { RelayDataProvider } from "@/api/services/RelayService";
import MosaiqClient from "@/api/clients/MosaiqClient";
import { AxiosRequestConfig } from "axios";
import store from "@/config/store";
import { Relay, RELAY_POINT_NAME_PREFIX } from "@/models/relay";
import Api from "@/api/Api";

export class SedMosaiqRelayProvider implements RelayDataProvider {

    fetchRelayPoints(): Promise<Relay[]> {
        const catalogName = process.env.VUE_APP_MOSAIQ_RELAY_CATALOG;
        const catalogPrefix = catalogName + "_";
        const territoryId = store.getters.getRootCategory.path.slice(0, -1); // remove trailing '/'
        const moqTerritoryId = Api.sed.getMoqIdByTerritorySlug(territoryId)
        const axiosRequestConfig: AxiosRequestConfig = {
          params: {
            columnFilters: JSON.stringify({
                [catalogName + "_type"]: ["PARCEL_PICKUP_POINT"],
                [catalogName + "_territory"]: moqTerritoryId
            })
          },
        };
        return MosaiqClient.of().get("locations/" + catalogName, axiosRequestConfig).then(
            (data) => {
              return data.data.map(moqRelayData => {
                  return {
                    identifiant: moqRelayData[catalogPrefix + "code"],
                    nom: moqRelayData[catalogPrefix + "name"],
                    adresse1: moqRelayData[catalogPrefix + "address"]["houseNumber"] + " " + moqRelayData[catalogPrefix + "address"]["street"],
                    adresse2: moqRelayData[catalogPrefix + "address"]["street2"],
                    adresse3: moqRelayData[catalogPrefix + "address"]["street3"],
                    localite: moqRelayData[catalogPrefix + "address"]["city"],
                    codePostal: moqRelayData[catalogPrefix + "address"]["postalCode"],
                    codePays: moqRelayData[catalogPrefix + "address"]["countryName"],
                    coordGeolocalisationLatitude: moqRelayData[catalogPrefix + "address"]["latitude"],
                    coordGeolocalisationLongitude: moqRelayData[catalogPrefix + "address"]["longitude"],
                    distanceEnMetre: 0,
                    horairesOuvertureDimanche: "00:00-00:00 00:00-00:00",
                    horairesOuvertureLundi: "00:10-12:00 14:10-19:00",
                    horairesOuvertureMardi: "00:00-12:00 14:10-19:00",
                    horairesOuvertureMercredi: "08:00-12:00 14:00-00:00",
                    horairesOuvertureJeudi: "00:00-00:00 00:00-00:00",
                    horairesOuvertureVendredi: "00:00-00:00 00:00-00:00",
                    horairesOuvertureSamedi: "00:00-00:00 00:00-00:00"
                };
              })
              .map(data => Relay.of(data));
            },
            err => {
              throw err;
            },
        );
    }

    getRelayPointById(relayPointId: string): Promise<Relay> {
      const expectedRelayPointName = RELAY_POINT_NAME_PREFIX + relayPointId
      return this.fetchRelayPoints().then(relayPoints => relayPoints.find(r => r.name == expectedRelayPointName) || Promise.reject("unknown relay point of id " + relayPointId))
    }

}